import Dropdown from './Dropdown';

export { Props } from './Dropdown';
export { Props as DropdownItemProps } from './DropdownItem';
// here DropdownItemProps has active that is of no use as it managed in dropdown

export default Dropdown;
